import { Markdown } from '@components/markdown'
import type { BentoPieceRectangleFourPartsFragment } from '@graphql/queries/GetBentoOne.graphql'
import type { FunctionComponent } from 'react'

import styles from './bento-rectangle-four-parts.module.scss'

export const Part: FunctionComponent<Props> = ({ copy }) => {
    return (
        <div className={styles.copy}>
            <Markdown tag='p' typeStyle='heading-xs' markdown={copy} />
        </div>
    )
}

export default Part

type Props = Omit<BentoPieceRectangleFourPartsFragment, 'sys' | 'type'> & {
    copy?: string
}
